import React, { useState } from 'react'
import CustomModal from '../../../../../components/modals/CustomModal'
import { Button, LoadingButton } from '../../../../../components/header/form'
import { cancelSubscriptionApi } from '../../../../../services/profile'
import { toastMessage } from '../../../../../utils/toastMessage'
import "./CancelSubscription.css";

const CancelSubscription = ({ show, close, selectedData, listing = () => { } }) => {
    const [loader, setLoading] = useState(false)
    // console.log('data', data)
    //---------add-subscription------------------
    const cancelSubscription = async () => {
        try {
            setLoading(true);
            const { data } = await cancelSubscriptionApi({ _id: selectedData?._id, });
            const { success, message, data: res } = data;
            if (success) {
                close();
                setTimeout(() => {
                    listing()
                }, 1000)
            }
            toastMessage(message, success ? "success" : "error", "cancelSubscription");
        } catch (e) {
            console.log("Error:-", e.message);
        } finally {
            setLoading(false);
        }
    };
    return (
        <CustomModal
            show={show}
            handleClose={close}
            className="CancelSubscription_model"
        >
            <h3 className="mb-3">Cancel Subscription</h3>
            <p className='cancel_subscrip_txt'>Are you sure want cancel <b>{selectedData?._group?.name || "this"}</b> subscription</p>
            <div className="button_wrap button_center cancel_subscrip_btn">
                <Button onClick={close}>No</Button>
                <LoadingButton loading={loader} onClick={cancelSubscription}>yes</LoadingButton>
            </div>
        </CustomModal>
    )
}

export default CancelSubscription